import { useNavigate } from '@tanstack/react-router';
import { ForwardedRef, forwardRef } from 'react';
import { Button } from './Button';
import { ButtonProps } from './ButtonProps';

export type RouteButtonProps = ButtonProps & {
  to: string;
  params?: Record<string, string>;
};

export const RouteButton = forwardRef(RouteButtonWithRef);
RouteButton.displayName = 'RouteButton';

/**
 * A Lighthouse `Button` that navigates instead of taking an `onClick`. Nothing else — it does not
 * style the button, so pick a `variant` per call site.
 */
function RouteButtonWithRef(
  { to, params, ...buttonProps }: RouteButtonProps,
  ref: ForwardedRef<HTMLButtonElement | null>,
) {
  const navigate = useNavigate();

  return (
    <Button
      ref={ref}
      {...buttonProps}
      onClick={() => {
        void navigate({ to, params });
      }}
    />
  );
}
